/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MembershipNull = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M2.53033 1L22.5303 21L21.4697 22.0607L18.939 19.53L1 19.5304V3.53033L2.939 3.53L1.46967 2.06066L2.53033 1ZM23 3.53033V19.47L21.5 17.97V5.03033L8.56 5.03L7.06 3.53L23 3.53033ZM7.065 7.65569L4.439 5.03L2.5 5.03033V18.0304L17.439 18.03L8.70558 9.29358C8.57768 9.27571 8.44668 9.26521 8.31014 9.26521C6.97182 9.26521 6.03713 10.2009 6.03713 11.5405C6.03713 12.948 7.06188 13.9309 8.52903 13.9309C9.44643 13.9309 10.4759 13.5422 11.3578 12.8634V14.7584C10.7625 15.1956 9.75772 15.7146 8.34367 15.7146C5.78613 15.7146 4 14.0318 4 11.6225C4 10.4077 4.42911 9.36815 5.24112 8.61641C5.74587 8.14893 6.37263 7.82167 7.065 7.65569ZM20 13.7803V15.2803L18.81 15.28L17.31 13.78L20 13.7803ZM20 10.7803V12.2803L15.81 12.28L14.31 10.78L20 10.7803ZM20 7.78033V9.28033H14V7.78033H20Z"
                        fill={color}
                    />
                </svg>
        );
    };
